// extracted by mini-css-extract-plugin
export default {"cls1":"TvQNJ_jyLhq66oCwsZIy","cls2":"MAFuhzpvNyX5ycRwS9tk TvQNJ_jyLhq66oCwsZIy"};